import * as actions from '../constants';

/**
 * Action to mark the application as loading
 */
export const requestAppLoad = (): any => ({
  type: actions.REQUEST_APP_LOAD,
});

/**
 * Action to mark the application as loaded
 */
export const receiveAppLoad = (): any => ({
  type: actions.RECEIVE_APP_LOAD,
});

/**
 * Open the mobile navigation
 */
export const openNavigation = (): any => ({
  type: actions.OPEN_NAVIGATION,
});

/**
 * Close the mobile navigation
 */
export const closeNavigation = (): any => ({
  type: actions.CLOSE_NAVIGATION,
});

/**
 * Action to request an image upload
 * @param {File} image
 */
export const requestUploadImage = (image): any => ({
  image,
  type: actions.REQUEST_UPLOAD_IMAGE,
});

/**
 * Action to mark an image upload as complete
 */
export const receiveUploadImage = (): any => ({
  type: actions.RECEIVE_UPLOAD_IMAGE,
});

/**
 * Upload an image
 * @param {File} image
 * @return {Promise}
 */
export const uploadImage = (image): any => (dispatch) => {
  dispatch(requestUploadImage(image));
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      dispatch(receiveUploadImage());
      resolve(reader.result);
    });
    reader.addEventListener('error', () => {
      reject();
    });
    reader.readAsDataURL(image);
  });
};

/**
 * Update the vehicle type filter
 * @param {Number} filterVehicleType
 */
export const updateVehicleTypeFilter = (filterVehicleType) => (dispatch) =>
  dispatch({
    filterVehicleType,
    type: actions.UPDATE_VEHICLE_TYPE_FILTER,
  });
